/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  BindSsoIdentityDto,
  CorporateAccountLookupDto,
  CorporateRegistrationRequest,
  CreateSsoUserDto,
  DataEnvelopeOfCorporateRegistrationDto,
  DataEnvelopeOfIReadOnlyListOfCorporateAccount,
  DataEnvelopeOfIReadOnlyListOfCorporateRegistrationDto,
  DataEnvelopeOfUserDto,
  GetCorporateRegistrationsParams,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const createSsoUser = (
  createSsoUserDto: CreateSsoUserDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfUserDto>(
    {
      url: `/v1/users/sso`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSsoUserDto,
      signal,
    },
    options,
  )
}

export const getCreateSsoUserMutationKey = () => ['createSsoUser'] as const

export const getCreateSsoUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSsoUser>>,
    TError,
    CreateSsoUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSsoUser>>,
  TError,
  CreateSsoUserMutationVariables,
  TContext
> => {
  const mutationKey = getCreateSsoUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSsoUser>>,
    CreateSsoUserMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createSsoUser(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateSsoUserMutationResult = NonNullable<Awaited<ReturnType<typeof createSsoUser>>>
export type CreateSsoUserMutationBody = CreateSsoUserDto
export type CreateSsoUserMutationError = unknown
export type CreateSsoUserMutationVariables = { data: CreateSsoUserDto }

export const useCreateSsoUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSsoUser>>,
      TError,
      CreateSsoUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSsoUser>>,
  TError,
  CreateSsoUserMutationVariables,
  TContext
> => {
  return useMutation(getCreateSsoUserMutationOptions(options), queryClient)
}
export const bindSsoIdentity = (
  id: string,
  bindSsoIdentityDto: BindSsoIdentityDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/v1/users/${id}/sso`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: bindSsoIdentityDto,
      signal,
    },
    options,
  )
}

export const getBindSsoIdentityMutationKey = () => ['bindSsoIdentity'] as const

export const getBindSsoIdentityMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bindSsoIdentity>>,
    TError,
    BindSsoIdentityMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof bindSsoIdentity>>,
  TError,
  BindSsoIdentityMutationVariables,
  TContext
> => {
  const mutationKey = getBindSsoIdentityMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bindSsoIdentity>>,
    BindSsoIdentityMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return bindSsoIdentity(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type BindSsoIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof bindSsoIdentity>>>
export type BindSsoIdentityMutationBody = BindSsoIdentityDto
export type BindSsoIdentityMutationError = unknown
export type BindSsoIdentityMutationVariables = { id: string; data: BindSsoIdentityDto }

export const useBindSsoIdentity = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bindSsoIdentity>>,
      TError,
      BindSsoIdentityMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bindSsoIdentity>>,
  TError,
  BindSsoIdentityMutationVariables,
  TContext
> => {
  return useMutation(getBindSsoIdentityMutationOptions(options), queryClient)
}
export const findCorporateAccounts = (
  corporateAccountLookupDto: CorporateAccountLookupDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIReadOnlyListOfCorporateAccount>(
    {
      url: `/v1/users/sso/corporate/lookup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: corporateAccountLookupDto,
      signal,
    },
    options,
  )
}

export const getFindCorporateAccountsMutationKey = () => ['findCorporateAccounts'] as const

export const getFindCorporateAccountsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findCorporateAccounts>>,
    TError,
    FindCorporateAccountsMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof findCorporateAccounts>>,
  TError,
  FindCorporateAccountsMutationVariables,
  TContext
> => {
  const mutationKey = getFindCorporateAccountsMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof findCorporateAccounts>>,
    FindCorporateAccountsMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return findCorporateAccounts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FindCorporateAccountsMutationResult = NonNullable<
  Awaited<ReturnType<typeof findCorporateAccounts>>
>
export type FindCorporateAccountsMutationBody = CorporateAccountLookupDto
export type FindCorporateAccountsMutationError = unknown
export type FindCorporateAccountsMutationVariables = { data: CorporateAccountLookupDto }

export const useFindCorporateAccounts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof findCorporateAccounts>>,
      TError,
      FindCorporateAccountsMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof findCorporateAccounts>>,
  TError,
  FindCorporateAccountsMutationVariables,
  TContext
> => {
  return useMutation(getFindCorporateAccountsMutationOptions(options), queryClient)
}
export const registerCorporateUser = (
  corporateRegistrationRequest: CorporateRegistrationRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCorporateRegistrationDto>(
    {
      url: `/v1/users/sso/corporate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: corporateRegistrationRequest,
      signal,
    },
    options,
  )
}

export const getRegisterCorporateUserMutationKey = () => ['registerCorporateUser'] as const

export const getRegisterCorporateUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerCorporateUser>>,
    TError,
    RegisterCorporateUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerCorporateUser>>,
  TError,
  RegisterCorporateUserMutationVariables,
  TContext
> => {
  const mutationKey = getRegisterCorporateUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerCorporateUser>>,
    RegisterCorporateUserMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return registerCorporateUser(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RegisterCorporateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerCorporateUser>>
>
export type RegisterCorporateUserMutationBody = CorporateRegistrationRequest
export type RegisterCorporateUserMutationError = unknown
export type RegisterCorporateUserMutationVariables = { data: CorporateRegistrationRequest }

export const useRegisterCorporateUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerCorporateUser>>,
      TError,
      RegisterCorporateUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerCorporateUser>>,
  TError,
  RegisterCorporateUserMutationVariables,
  TContext
> => {
  return useMutation(getRegisterCorporateUserMutationOptions(options), queryClient)
}
export const getCorporateRegistrations = (
  params: GetCorporateRegistrationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIReadOnlyListOfCorporateRegistrationDto>(
    { url: `/v1/users/sso/corporate/status`, method: 'GET', params, signal },
    options,
  )
}

export const getGetCorporateRegistrationsQueryKey = (params?: GetCorporateRegistrationsParams) => {
  return [`/v1/users/sso/corporate/status`, ...(params ? [params] : [])] as const
}

export const getGetCorporateRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCorporateRegistrations>>,
  TError = unknown,
>(
  params: GetCorporateRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCorporateRegistrations>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCorporateRegistrationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCorporateRegistrations>>> = ({
    signal,
  }) => getCorporateRegistrations(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCorporateRegistrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCorporateRegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCorporateRegistrations>>
>
export type GetCorporateRegistrationsQueryError = unknown

export function useGetCorporateRegistrations<
  TData = Awaited<ReturnType<typeof getCorporateRegistrations>>,
  TError = unknown,
>(
  params: GetCorporateRegistrationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCorporateRegistrations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCorporateRegistrations>>,
          TError,
          Awaited<ReturnType<typeof getCorporateRegistrations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCorporateRegistrations<
  TData = Awaited<ReturnType<typeof getCorporateRegistrations>>,
  TError = unknown,
>(
  params: GetCorporateRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCorporateRegistrations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCorporateRegistrations>>,
          TError,
          Awaited<ReturnType<typeof getCorporateRegistrations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCorporateRegistrations<
  TData = Awaited<ReturnType<typeof getCorporateRegistrations>>,
  TError = unknown,
>(
  params: GetCorporateRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCorporateRegistrations>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCorporateRegistrations<
  TData = Awaited<ReturnType<typeof getCorporateRegistrations>>,
  TError = unknown,
>(
  params: GetCorporateRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCorporateRegistrations>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCorporateRegistrationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const resendCorporateInvitation = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCorporateRegistrationDto>(
    { url: `/v1/users/sso/corporate/${id}/resend`, method: 'POST', signal },
    options,
  )
}

export const getResendCorporateInvitationMutationKey = () => ['resendCorporateInvitation'] as const

export const getResendCorporateInvitationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendCorporateInvitation>>,
    TError,
    ResendCorporateInvitationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendCorporateInvitation>>,
  TError,
  ResendCorporateInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getResendCorporateInvitationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendCorporateInvitation>>,
    ResendCorporateInvitationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return resendCorporateInvitation(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResendCorporateInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendCorporateInvitation>>
>

export type ResendCorporateInvitationMutationError = unknown
export type ResendCorporateInvitationMutationVariables = { id: string }

export const useResendCorporateInvitation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendCorporateInvitation>>,
      TError,
      ResendCorporateInvitationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendCorporateInvitation>>,
  TError,
  ResendCorporateInvitationMutationVariables,
  TContext
> => {
  return useMutation(getResendCorporateInvitationMutationOptions(options), queryClient)
}
